<template>
  <div class="uk-grid-medium uk-flex-center uk-text-center ContactInfo" uk-grid>
    <div class="uk-width-1-2@m uk-width-1-2@l">
      <article class="uk-article">
        <img class="Logo" :src="`${ASSETS_BASE_URL}/images/logo.png`"/>
        <h2 class="uk-article-title AppTitle Title">{{'about_us_view.contact_us'|translate}}</h2>
        <div class="uk-text-lead Description">
          <div class="contact-details">
            <ul class="uk-list">
              <li class="Text">Homewind Leisures</li>
              <li class="Text">No.&nbsp;21, Siebel Avenue,</li>
              <li class="Text">Colombo 5, Sri Lanka</li>
              <li class="Text BoldFont">D:&nbsp;(+94)112827527</li>
              <li class="Text BoldFont">M:&nbsp;(+94)770035464</li>
              <li class="Text BoldFont">E:&nbsp;info@homewindleisures.com</li>
            </ul>
          </div>
          <div>
            <a href="https://www.facebook.com/HomewindLeisures" target="_blank" class="uk-icon-button uk-margin-small-right social-media-icon" uk-icon="facebook"></a>
            <a href="https://www.instagram.com/homewindleisures" target="_blank" class="uk-icon-button  uk-margin-small-right social-media-icon" uk-icon="instagram"></a>
            <a href="https://www.youtube.com/channel/UC7nWPW6gvIWLVh7y8dB9B1Q" target="_blank" class="uk-icon-button social-media-icon" uk-icon="youtube"></a>
          </div>
        </div>
      </article>
    </div>
    <div class="uk-width-1-2@m uk-width-1-2@l">
      <div class="uk-cover-container uk-height-large">
        <iframe
          :src="embeddedMapUrl"
          width="900" height="450" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactInfoComponent',
  props: ['title', 'moto', 'description', 'embeddedMapUrl']
}
</script>

<style scoped>
  .Logo {
    width: 380px;
    /*margin-top: 25px;*/
  }

  .ContactInfo {
    padding-top: 80px;
    margin-bottom: 40px;
  }

  .Title {
    margin-top: 20px;
    padding-top: 0;
  }

  .Description {
    margin-bottom: 25px;
  }

  .contact-details {
    font-size: 16px;
  }

  .contact-details > .uk-list {
    margin-bottom: 10px;
  }

  .BoldFont {
    font-weight: bold;
  }
</style>
